import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deleteProductById } from 'api/auth.api';

export const useProductDelete = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProductById,

    onSuccess: (res) => {
      queryClient.invalidateQueries(['productList']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete product',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
